import "core-js/modules/es.string.fixed.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "index-form"
  }, [_c("a-form", {
    attrs: {
      form: _vm.form
    }
  }, [_c("a-alert", {
    attrs: {
      message: _vm.$t("form.indexTip"),
      "show-icon": ""
    }
  }), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.sticky")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.is"),
      "un-checked-children": _vm.$t("form.no")
    },
    model: {
      value: _vm.value.fixed,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "fixed", $$v);
      },
      expression: "value.fixed"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.textColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "textColor", $$v);
      },
      expression: "value.textColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textSelectColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.hoverTextColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "hoverTextColor", $$v);
      },
      expression: "value.hoverTextColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textSize"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.fontSize,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "fontSize", $$v);
      },
      expression: "value.fontSize"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };